import { SkeletonBlock } from '../customer-area'

export const OrderDetailSkeleton = () => (
  <div className="space-y-5">
    <section className="ca-card-shell ca-theme-transition rounded-xl px-5 py-5">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <SkeletonBlock className="h-3 w-20 rounded-md" />
          <SkeletonBlock className="mt-2 h-6 w-56 rounded-md" />
          <SkeletonBlock className="mt-2 h-3 w-44 rounded-md" />
        </div>
        <SkeletonBlock className="h-6 w-24 rounded-full" />
      </div>
      <div className="mt-3">
        <SkeletonBlock className="h-9 w-28 rounded-md" />
      </div>
    </section>

    <div className="grid gap-5 xl:grid-cols-[minmax(0,1fr)_320px] xl:items-start">
      <div className="space-y-5">
        <section className="ca-card-shell ca-theme-transition rounded-xl px-5 py-5">
          <SkeletonBlock className="h-4 w-40 rounded-md" />
          <div className="mt-3 space-y-3">
            {Array.from({ length: 2 }).map((_, index) => (
              <div
                key={`items-skeleton-${index}`}
                className="grid gap-3 rounded-xl border border-(--color-border-default) bg-(--color-bg-surface-muted) px-3 py-3 sm:grid-cols-[64px_minmax(0,1fr)_auto] sm:items-center"
              >
                <SkeletonBlock className="h-16 w-16 rounded-lg" />
                <div className="space-y-2">
                  <SkeletonBlock className="h-4 w-44 rounded-md" />
                  <SkeletonBlock className="h-3 w-20 rounded-md" />
                </div>
                <div className="space-y-2 sm:text-right">
                  <SkeletonBlock className="h-3 w-24 rounded-md" />
                  <SkeletonBlock className="h-4 w-20 rounded-md" />
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="ca-card-shell ca-theme-transition rounded-xl px-5 py-5">
          <SkeletonBlock className="h-4 w-32 rounded-md" />
          <SkeletonBlock className="mt-2 h-3 w-72 rounded-md" />
          <SkeletonBlock className="mt-4 h-1 w-full rounded-full" />
          <div className="mt-3 grid gap-3 sm:grid-cols-3">
            {Array.from({ length: 3 }).map((_, index) => (
              <div
                key={`timeline-card-skeleton-${index}`}
                className="rounded-lg border border-(--color-border-default) bg-(--color-bg-surface-muted) px-3.5 py-3"
              >
                <SkeletonBlock className="h-4 w-24 rounded-md" />
                <SkeletonBlock className="mt-2 h-3 w-28 rounded-md" />
              </div>
            ))}
          </div>
        </section>

        <section className="ca-card-shell ca-theme-transition rounded-xl px-5 py-5">
          <SkeletonBlock className="h-4 w-36 rounded-md" />
          <SkeletonBlock className="mt-3 h-3 w-52 rounded-md" />
          <SkeletonBlock className="mt-1.5 h-3 w-40 rounded-md" />
        </section>

        <section className="ca-card-shell ca-theme-transition rounded-xl px-5 py-5">
          <SkeletonBlock className="h-4 w-20 rounded-md" />
          <SkeletonBlock className="mt-2 h-3 w-64 rounded-md" />
          <div className="mt-3 space-y-3">
            {Array.from({ length: 2 }).map((_, index) => (
              <div
                key={`invoice-skeleton-${index}`}
                className="rounded-xl border border-(--color-border-default) bg-(--color-bg-surface-muted) px-4 py-3"
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="space-y-2">
                    <SkeletonBlock className="h-4 w-32 rounded-md" />
                    <SkeletonBlock className="h-3 w-40 rounded-md" />
                  </div>
                  <SkeletonBlock className="h-8 w-28 rounded-md" />
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      <div className="space-y-4 xl:sticky xl:top-6">
        <section className="ca-card-shell ca-theme-transition rounded-xl px-5 py-5">
          <SkeletonBlock className="h-3 w-16 rounded-md" />
          <SkeletonBlock className="mt-2 h-8 w-32 rounded-md" />
          <div className="mt-4 space-y-2">
            <SkeletonBlock className="h-3 w-full rounded-md" />
            <SkeletonBlock className="h-3 w-full rounded-md" />
          </div>
          <div className="mt-4 border-t border-(--color-border-default) pt-3.5">
            <div className="flex items-center gap-3">
              <SkeletonBlock className="h-8 w-8 rounded-md" />
              <div className="space-y-1.5">
                <SkeletonBlock className="h-3.5 w-32 rounded-md" />
                <SkeletonBlock className="h-3 w-24 rounded-md" />
              </div>
            </div>
          </div>
        </section>

        <section className="ca-card-shell ca-theme-transition rounded-xl px-4 py-4">
          <SkeletonBlock className="h-4 w-24 rounded-md" />
          <SkeletonBlock className="mt-2 h-3 w-full rounded-md" />
          <SkeletonBlock className="mt-3 h-9 w-full rounded-md" />
        </section>
      </div>
    </div>
  </div>
)
